import call from "../../../dashboard/service/http";
import constants from "./contactConstants";
export default {
  state: {
    contacts: [],
    contact: {},
  },
  mutations: {
    SET_CONTACTS: (state, payload) => {
      state.contacts = payload;
    },
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    contacts: (state) => state.contacts,
    contactGetters: (state) => (value) => state[value],
  },
  actions: {
    getContact: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.contact(data))
        .then((res) => {
          commit("MUTATE", { state: "contact", data: res.data.data[0] });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    editContact: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.postContact, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to contacts
          Event.$emit("bactToList");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    submitContact: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.postContact, data)
        .then((res) => {
          Event.$emit("ApiSuccess", res.data.message);
          // back to contacts
          Event.$emit("bactToList");
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    deleteContact: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", constants.deleteContact(data), data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Profile/getProfile");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
